import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import NoticesHistory from "./history/history";
import Categories from "./admin/categories";
import "../../../styles/css/App.css";

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/history`}>
        <NoticesHistory />
      </Route>
      <Route path={`${base}/categories`}>
        <Categories />
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
